// The visual wrapper for one revealed subsection of the quote-level "What do you
// need us to do with it?" card — a titled block under the card's own heading, so
// its `h4` sits below the card's `h3`.
//
// It lives in its own file because two components render one: OrderServicesForm
// for the delivery modes plus the assembly block, and ProofDeliveryForm for
// the printed samples. Keeping it private to OrderServicesForm would mean either
// a second hand-rolled copy of the markup to keep in step, or an import cycle
// between the two components.
//
// `id` is the block's scroll/reveal target. For a subsection revealed by a card
// it is also that card's `aria-controls` partner (the disclosure pattern); for
// one revealed by quote state rather than a click, nothing points at it and the
// id is a scroll target alone.
//
// `title` is optional: a delivery-mode subsection omits it because the card
// that reveals it already names and describes the mode.

import type { ReactNode } from 'react';

export function OrderSubsection(props: {
  id: string;
  title?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div id={props.id} className="order-subsection">
      {props.title && <h4 className="order-subsection__title">{props.title}</h4>}
      {props.children}
    </div>
  );
}
